import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnChanges, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { ServerHtmlDirective } from 'ish-core/directives/server-html.directive';
import { ShoppingFacade } from 'ish-core/facades/shopping.facade';
import { BasketRebate } from 'ish-core/models/basket-rebate/basket-rebate.model';
import { Promotion } from 'ish-core/models/promotion/promotion.model';
import { PromotionDetailsComponent } from 'ish-shared/components/promotion/promotion-details/promotion-details.component';
import { PromotionRemoveComponent } from 'ish-shared/components/promotion/promotion-remove/promotion-remove.component';

@Component({
  selector: 'ish-basket-promotion',
  templateUrl: './basket-promotion.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ServerHtmlDirective, PromotionDetailsComponent, PromotionRemoveComponent, AsyncPipe, TranslateModule],
})
export class BasketPromotionComponent implements OnChanges {
  private shoppingFacade = inject(ShoppingFacade);

  readonly rebate = input.required<BasketRebate>();

  promotion$: Observable<Promotion>;

  ngOnChanges() {
    const rebate = this.rebate();
    if (rebate?.promotionId) {
      this.promotion$ = this.shoppingFacade.promotion$(rebate.promotionId);
    }
  }
}
